module.exports = __webpack_public_path__ + "static/media/js.bcc5275c.svg";